export default class PaginationModel<T> {
    list: Array<T> = [];
    total: number = null;
    pageIndex: number = null;
    pageSize: number = null;
}